export const QUESTION_TYPES = {
  MCQ: 'multiple_choice',
  FRQ: 'free_response',
};

export const questionTypes = {
  [QUESTION_TYPES.MCQ]: {
    label: 'Multiple Choice',
    value: QUESTION_TYPES.MCQ,
  },
  [QUESTION_TYPES.FRQ]: {
    label: 'Free Response',
    value: QUESTION_TYPES.FRQ,
  },
};
